import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';
import { Button } from '../Button';
import reviewStyles from './writeReview-tw-styles';

class SorryModal extends React.Component {
  static propTypes = {
    form: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.shape({
        fields: PropTypes.object,
      }),
    ]).isRequired,
  };

  render() {
    let { form } = this.props;
    let formData = form && form.fields;
    const i18nMessages = require(`../../../constants/messages/pt-BR`);
    let closeClick = () => {
      let sorryModalVal = formData.sorryModal;
      sorryModalVal.value = false;
      let isSubmitVal = formData.isSubmit;
      isSubmitVal.value = false;
    };

    return formData.sorryModal.value ? (
      <div className={classNames(reviewStyles.sorryThanks.modalWrapper)}>
        <div className={classNames(reviewStyles.sorryThanks.modalBG)}>
          <div className={classNames(reviewStyles.sorryThanks.modalTitle)}>
            <span className={classNames(reviewStyles.sorryThanks.modalHeader)}>
              {
                <FormattedMessage
                  id={i18nMessages.reviewSorry}
                  defaultMessage={i18nMessages.reviewSorry}
                />
              }
            </span>
            <Button
              className={classNames(reviewStyles.sorryThanks.modalClose)}
              onClick={closeClick}
            >
              <span className={classNames(reviewStyles.sorryThanks.closeIcon)}>
                {`×`}
              </span>
            </Button>
          </div>

          <div className={classNames(reviewStyles.sorryThanks.dialogWrapper)}>
            <p className={classNames(reviewStyles.sorryThanks.dialogContent)}>
              {
                <FormattedMessage
                  id={i18nMessages.reviewSorryContent}
                  defaultMessage={i18nMessages.reviewSorryContent}
                />
              }
            </p>
            <div className={classNames(reviewStyles.sorryThanks.buttonWrapper)}>
              <a
                data-pgaction-redirection="0"
                className={classNames(reviewStyles.sorryThanks.buttonClass)}
                href="javascript:void(0);"
                onClick={closeClick}
              >
                {
                  <FormattedMessage
                    id={i18nMessages.reviewContinueButton}
                    defaultMessage={i18nMessages.reviewContinueButton}
                  />
                }
              </a>
            </div>
          </div>
        </div>
      </div>
    ) : (
      ''
    );
  }
}

export default observer(SorryModal);
